// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"63ef362b","78":"2459db4b","104":"67e58bdd"}[chunkId] + ".chunk.js";
};